function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
function sumOriginalTotal(items, discountTaxOrder) {
    var originalTotalPrice = Big(0);
    // Iterate over products to determine originalTotalPrice
    _.forEach(items, function(param) {
        var basePrice = param.basePrice, basePriceMult = param.basePriceMult, mixAndMatch = param.mixAndMatch, quantity = param.quantity;
        var adjustedBasePrice = (mixAndMatch === null || mixAndMatch === void 0 ? void 0 : mixAndMatch.adjustedBasePrice) || basePrice || 0;
        originalTotalPrice = originalTotalPrice.add(// Multiply basePrice by the tax mult to account for taxes in the menu or from POS for taxesFirst setting
        adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? basePriceMult || 1 : 1).times(quantity));
    });
    return originalTotalPrice;
}
var issueDiscountToCartRewards = function(bogoCalcsData, bogoSpecial, discountTaxOrder, items) {
    var discountToCart = bogoSpecial.discountToCart, specialId = bogoSpecial.specialId, specialName = bogoSpecial.specialName;
    var rewardId = discountToCart === null || discountToCart === void 0 ? void 0 : discountToCart._id;
    var targetIndividualDiscountPercentage = Big(0);
    var originalTotalPrice = sumOriginalTotal(items, discountTaxOrder);
    var _discountToCart_value;
    var totalDiscount = (discountToCart === null || discountToCart === void 0 ? void 0 : discountToCart.discountType) === 'percentDiscount' ? originalTotalPrice.times(Big((_discountToCart_value = discountToCart === null || discountToCart === void 0 ? void 0 : discountToCart.value) !== null && _discountToCart_value !== void 0 ? _discountToCart_value : 0).div(100)) : Big(discountToCart === null || discountToCart === void 0 ? void 0 : discountToCart.value);
    /*
    taking the total discount and dividing it by the cart total will leave
    you with the percentage of each product that needs to be discounted
   */ if (originalTotalPrice.gt(0)) {
        targetIndividualDiscountPercentage = totalDiscount.div(originalTotalPrice);
    }
    if (targetIndividualDiscountPercentage.lt(0)) {
        return {};
    }
    // filter out products that have had their DTC reward defeated
    var itemsNotDefeatedByOtherRewards = _.filter(items, function(param) {
        var key = param.key;
        var _bogoCalcsData_defeatedDiscountToCartRewards_rewardId, _bogoCalcsData_defeatedDiscountToCartRewards;
        return !((_bogoCalcsData_defeatedDiscountToCartRewards = bogoCalcsData.defeatedDiscountToCartRewards) === null || _bogoCalcsData_defeatedDiscountToCartRewards === void 0 ? void 0 : (_bogoCalcsData_defeatedDiscountToCartRewards_rewardId = _bogoCalcsData_defeatedDiscountToCartRewards[rewardId]) === null || _bogoCalcsData_defeatedDiscountToCartRewards_rewardId === void 0 ? void 0 : _bogoCalcsData_defeatedDiscountToCartRewards_rewardId[key]);
    });
    /*
    when one or more product has it's DTC cart reward defeated, we need to
    take the same overall discount and spread it evenly across the remaining
    products so that the overall DTC value is preserved
   */ var atleastOneProductRemainsUndefeated = itemsNotDefeatedByOtherRewards.length > 0 && itemsNotDefeatedByOtherRewards.length < items.length;
    if (atleastOneProductRemainsUndefeated) {
        var totalPriceMinusProductsWithRewards = sumOriginalTotal(itemsNotDefeatedByOtherRewards, discountTaxOrder);
        // here the targetIndividualDiscountPercentage will increase by some amount
        // so the discount will be larger for the remaining products
        if (totalPriceMinusProductsWithRewards.gt(0)) {
            targetIndividualDiscountPercentage = totalDiscount.div(totalPriceMinusProductsWithRewards);
        }
    }
    var discountToCartRewards = {};
    _.forEach(itemsNotDefeatedByOtherRewards, function(item) {
        var _item_mixAndMatch, _bogoCalcsData_discountToCartRewards_item_key_rewards, _bogoCalcsData_discountToCartRewards_item_key, _bogoCalcsData_discountToCartRewards, _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId_reward, _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId, _bogoCalcsData_discountToCartRewards_item_key_rewards1, _bogoCalcsData_discountToCartRewards_item_key1, _bogoCalcsData_discountToCartRewards1;
        var adjustedBasePrice = Big(((_item_mixAndMatch = item.mixAndMatch) === null || _item_mixAndMatch === void 0 ? void 0 : _item_mixAndMatch.adjustedBasePrice) || item.basePrice || 0);
        var discount = adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? Big(item.basePriceMult || 1) : 1).times(targetIndividualDiscountPercentage);
        /*
      if the defeated discounts end up stacking onto
      one or more products and the discount is too large
      we want to 0 out the product instead
      of over discounting a single product
    */ if (discount.gt(adjustedBasePrice)) {
            discount = adjustedBasePrice;
        }
        var hasPreviousDTCReward = !!((_bogoCalcsData_discountToCartRewards = bogoCalcsData.discountToCartRewards) === null || _bogoCalcsData_discountToCartRewards === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key = _bogoCalcsData_discountToCartRewards[item.key]) === null || _bogoCalcsData_discountToCartRewards_item_key === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key_rewards = _bogoCalcsData_discountToCartRewards_item_key.rewards) === null || _bogoCalcsData_discountToCartRewards_item_key_rewards === void 0 ? void 0 : _bogoCalcsData_discountToCartRewards_item_key_rewards[rewardId]);
        var redemptionMultiplier = hasPreviousDTCReward ? (_bogoCalcsData_discountToCartRewards1 = bogoCalcsData.discountToCartRewards) === null || _bogoCalcsData_discountToCartRewards1 === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key1 = _bogoCalcsData_discountToCartRewards1[item.key]) === null || _bogoCalcsData_discountToCartRewards_item_key1 === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key_rewards1 = _bogoCalcsData_discountToCartRewards_item_key1.rewards) === null || _bogoCalcsData_discountToCartRewards_item_key_rewards1 === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId = _bogoCalcsData_discountToCartRewards_item_key_rewards1[rewardId]) === null || _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId === void 0 ? void 0 : (_bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId_reward = _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId.reward) === null || _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId_reward === void 0 ? void 0 : _bogoCalcsData_discountToCartRewards_item_key_rewards_rewardId_reward.redemptionMultiplier : 0;
        discountToCartRewards[item.key] = {
            item: item,
            quantity: item.quantity,
            rewards: _define_property({}, rewardId, {
                quantity: item.quantity,
                reward: {
                    _id: rewardId,
                    dollarDiscount: Big(discount),
                    discountToCart: _object_spread({}, discountToCart),
                    redemptionMultiplier: redemptionMultiplier + 1
                },
                specialId: specialId,
                specialName: specialName,
                discountStacking: bogoSpecial.discountStacking,
                discountPrecedence: bogoSpecial.discountPrecedence,
                stackingBehavior: bogoSpecial.stackingBehavior,
                nonStackingBehavior: bogoSpecial.nonStackingBehavior,
                settingsDerivedFrom: bogoSpecial.settingsDerivedFrom
            })
        };
    });
    return discountToCartRewards;
};
export default issueDiscountToCartRewards;
